import { c as _c } from "react/compiler-runtime";
import type { EntityStatus, TerminalDecisionStatus, VaultKind } from '@onefootprint/request-types/dashboard';
import { useQueryState } from 'nuqs';
import { useState } from 'react';
import ManualReviewDialog from './components/manual-review-dialog';
import ManualReviewTrigger from './components/manual-review-trigger';
export type ManualReviewProps = {
  disabled?: boolean;
  kind: VaultKind;
  status: EntityStatus;
  size?: 'compact' | 'default';
};
const ManualReview = t0 => {
  const $ = _c(20);
  const {
    kind,
    status,
    disabled,
    size
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      defaultValue: null,
      history: "push",
      parse: _temp
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [terminalDecisionStatus, setTerminalDecisionStatus] = useQueryState("manual-review-dialog", t1);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dialogOpen = terminalDecisionStatus !== null;
  let t2;
  if ($[1] !== setTerminalDecisionStatus) {
    t2 = dialogStatus => {
      setDropdownOpen(false);
      setTerminalDecisionStatus(dialogStatus);
    };
    $[1] = setTerminalDecisionStatus;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleSelect = t2;
  let t3;
  if ($[3] !== setTerminalDecisionStatus) {
    t3 = () => {
      setTerminalDecisionStatus(null);
    };
    $[3] = setTerminalDecisionStatus;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const handleCloseDialog = t3;
  let t4;
  if ($[5] !== disabled || $[6] !== dropdownOpen || $[7] !== handleSelect || $[8] !== kind || $[9] !== size || $[10] !== status) {
    t4 = <ManualReviewTrigger disabled={disabled} kind={kind} onOpenChange={setDropdownOpen} onSelect={handleSelect} open={dropdownOpen} size={size} status={status} />;
    $[5] = disabled;
    $[6] = dropdownOpen;
    $[7] = handleSelect;
    $[8] = kind;
    $[9] = size;
    $[10] = status;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== dialogOpen || $[13] !== disabled || $[14] !== handleCloseDialog || $[15] !== terminalDecisionStatus) {
    t5 = disabled ? null : <ManualReviewDialog onClose={handleCloseDialog} open={dialogOpen} status={terminalDecisionStatus} />;
    $[12] = dialogOpen;
    $[13] = disabled;
    $[14] = handleCloseDialog;
    $[15] = terminalDecisionStatus;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== t4 || $[18] !== t5) {
    t6 = <>{t4}{t5}</>;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  return t6;
};
export default ManualReview;
function _temp(value) {
  return value === "pass" || value === "fail" ? value : null;
}